export const AllInIntegrationsBase = (superclass) => class extends superclass {
    async _getTicketingProviderConfig() {
        try {
            let response = await fetch(this.restUrl + `?action=get_integration_config&org_id=${this.currentOrg}&nonce=${this.nonce}`, {
                method: 'GET',
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            let data = await response.json();
            if (!this.organisation.hasOwnProperty('integration_config')) {
                this.organisation.integration_config = {};
            }
            this.providerConfig = data.integration_config;
            this.providerConfigMapping = data.integration_config?.mappings;
            this.organisation.integration_config = data.integration_config;
            this._updateContext({ organisation: this.organisation, providerConfig: this.providerConfig, providerConfigMapping: this.providerConfigMapping });
        }
        catch (error) {
            console.error('Error:', error);
        }
        finally {
            this.loading = false;
        }
    }
    _showPanel(panel, view) {
        this.panel = panel;
        let name = '';
        if (this.panel == 'event-configuration') {
            name = 'Event Listings Data Integration';
        }
        else if (this.panel == 'ticketing-provider-configuration') {
            name = 'Ticketing Provider Data Integration';
        }
        else if (this.panel == 'member-configuration') {
            name = 'Member Data Integration';
        }
        if (view) {
            panel += `/${view}`;
        }
        this._updateContext({ panel: this.panel, view: view ?? '' });
        let crumb = {
            organisation: { url: `/organisation-dashboard/${this.currentOrg}/`, title: `${this.organisation?.name}` },
            dashboard: { url: `/organisation-dashboard/${this.currentOrg}/integrations/`, title: `Integrations` },
            panel: { url: `/organisation-dashboard/${this.currentOrg}/integrations/${panel}/`, title: name }
        };
        this.eventManager.emit(`allin-breadcrumb-${this.name}`, crumb);
        this.eventManager.addHistory('/organisation-dashboard/' + this.currentOrg + '/integrations/' + panel, { panel: this.panel });
    }
    _hidePanel() {
        this.panel = '';
        this._updateContext({ panel: this.panel, view: '' });
        let crumb = {
            organisation: { url: `/organisation-dashboard/${this.currentOrg}/`, title: `${this.organisation?.name}` },
            dashboard: { url: `/organisation-dashboard/${this.currentOrg}/integrations/`, title: `Integrations` }
        };
        this.eventManager.emit(`allin-breadcrumb-${this.name}`, crumb);
        this.eventManager.addHistory('/organisation-dashboard/' + this.currentOrg + '/integrations', { panel: '' });
        this.eventManager.emit(`allin-organisation-${this.name}-switcher`, { dashboard: 'integrations', panel: `` });
        this.partial = false;
    }
};
